import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, API } from "../lib/api";
import { Award, GraduationCap, ArrowRight, FileBadge } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import BadgeShare from "./BadgeShare";

export default function RoadReadyBadge() {
  const { user } = useAuth();
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/learn/progress").then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p) return null;
  const pct = Math.round((p.completed / p.total) * 100);
  return (
    <section className={`p-5 rounded-2xl border flex items-center gap-4 ${p.road_ready ? "bg-amber-400/10 border-amber-400/40" : "bg-[#131722] border-slate-800"}`} data-testid="road-ready-card">
      <div className={`w-14 h-14 rounded-full flex items-center justify-center shrink-0 ${p.road_ready ? "bg-amber-400 text-slate-950 shadow-[0_0_30px_-5px_rgba(251,191,36,.8)]" : "bg-slate-900 border border-slate-700 text-slate-500"}`}>
        {p.road_ready ? <Award className="w-7 h-7" /> : <GraduationCap className="w-6 h-6" />}
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-mono text-[10px] tracking-widest uppercase text-slate-400">{p.road_ready ? "Badge earned" : "Raq's manual"}</p>
        <h3 className="font-display font-bold" data-testid="road-ready-title">{p.road_ready ? "Road Ready" : `${p.completed} of ${p.total} chapter checks passed`}</h3>
        {!p.road_ready && <div className="mt-2 h-1.5 rounded-full bg-slate-800 overflow-hidden"><div className="h-full bg-cyan-400 transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>}
        {p.road_ready && <p className="text-xs text-amber-200/80 mt-0.5">You completed every chapter of Raq's manual. You get first pick on new delivery runs.</p>}
        {p.road_ready && user && <div className="mt-3 space-y-2"><BadgeShare userId={user.id} name={user.name} />
          <a href={`${API}/learn/certificate.pdf`} download data-testid="certificate-download" className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg bg-amber-400 text-slate-950 text-xs font-semibold hover:bg-amber-300"><FileBadge className="w-3.5 h-3.5" />Download certificate (PDF)</a></div>}
      </div>
      {!p.road_ready && <Link to="/learn" className="text-xs text-cyan-300 font-mono flex items-center gap-1 whitespace-nowrap" data-testid="road-ready-continue">Continue <ArrowRight className="w-3 h-3" /></Link>}
    </section>
  );
}
